// extracted by mini-css-extract-plugin
export default {"fileFormatCol":"ReportsTableWidget_fileFormatCol__bTDAF","fileFormat":"ReportsTableWidget_fileFormat__rXhFh","fileFormatSpinner":"ReportsTableWidget_fileFormatSpinner__NRs89"};